export const Cash = (props) => {
  const { size = 20, onClick, verticalAlign, marginLeft, marginRight, top, color, className = ' ' } = props;
  return (
    <span onClick={onClick} className={`icon-wrap ${className}`} style={{ marginLeft, marginRight, top, color }}>
      <svg xmlns='http://www.w3.org/2000/svg' style={{ verticalAlign }} width={size} height={size} fill='none' viewBox='0 0 20 20'>
        <path
          stroke='currentColor'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='1.25'
          d='M10 13.25H3.25a1.583 1.583 0 01-1.583-1.583V4.083c0-.875.708-1.583 1.583-1.583h12.667c.875 0 1.583.708 1.583 1.583v4.25M15 5h-.833M5 10.833h-.833M12.501 14c0 .644 1.306 1.167 2.917 1.167 1.61 0 2.916-.523 2.916-1.167m-5.833 0v-2.333m0 2.333v2.333c0 .645 1.305 1.167 2.916 1.167 1.61 0 2.916-.523 2.917-1.167V14m0 0v-2.333m-5.833 0c0 .644 1.306 1.166 2.917 1.166 1.61 0 2.916-.522 2.916-1.166m-5.833 0c.001-.644 1.306-1.167 2.916-1.167 1.61 0 2.917.522 2.917 1.167m-7.351-5.024a1.98 1.98 0 11-2.802 2.799 1.98 1.98 0 012.802-2.8z'
        ></path>
      </svg>
    </span>
  );
};
